import { z } from 'zod';

export const materialInventoryFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(255, 'El nombre debe tener máximo 255 caracteres'),
  code: z.string()
    .max(100, 'El código debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  category: z.string()
    .max(100, 'La categoría debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  material_type: z.string()
    .max(100, 'El tipo de material debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  unit: z.string()
    .max(50, 'La unidad debe tener máximo 50 caracteres')
    .default('kg'),
  current_stock: z.number()
    .min(0, 'El stock actual debe ser mayor o igual a 0')
    .default(0),
  min_stock: z.number()
    .min(0, 'El stock mínimo debe ser mayor o igual a 0')
    .default(0),
  max_stock: z.number()
    .min(0, 'El stock máximo debe ser mayor o igual a 0')
    .optional(),
  cost_per_unit: z.number()
    .min(0, 'El costo por unidad debe ser mayor o igual a 0')
    .optional(),
  location: z.string()
    .max(255, 'La ubicación debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  supplier: z.string()
    .max(255, 'El proveedor debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  batch_number: z.string()
    .max(100, 'El número de lote debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  roll_number: z.string()
    .max(100, 'El número de rollo debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  roll_count: z.number()
    .int('La cantidad de rollos debe ser un número entero')
    .min(0, 'La cantidad de rollos debe ser mayor o igual a 0')
    .optional(),
  production_date: z.string()
    .optional()
    .or(z.literal('')),
  expiry_date: z.string()
    .optional()
    .or(z.literal('')),
  storage_location: z.string()
    .max(255, 'La ubicación de almacenamiento debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  storage_temperature: z.string()
    .max(50, 'La temperatura de almacenamiento debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  storage_humidity: z.string()
    .max(50, 'La humedad de almacenamiento debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  safety_data_sheet_url: z.string()
    .url('Debe ser una URL válida')
    .max(500, 'La URL debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  last_restock_date: z.string()
    .optional()
    .or(z.literal('')),
  notes: z.string()
    .max(2000, 'Las notas deben tener máximo 2000 caracteres')
    .optional()
    .or(z.literal('')),
  is_freezer_material: z.boolean().default(false),
  max_out_time_minutes: z.number()
    .int("Debe ser un número entero")
    .min(5, "Mínimo 5 minutos")
    .max(99999, "Máximo 99999 minutos")
    .default(120),
  is_active: z.boolean().default(true),
});

export type MaterialInventoryFormData = z.infer<typeof materialInventoryFormSchema>;
